import { render, staticRenderFns } from "./VesselHistory.vue?vue&type=template&id=a059874e&scoped=true"
import script from "./VesselHistory.vue?vue&type=script&lang=js"
export * from "./VesselHistory.vue?vue&type=script&lang=js"
import style0 from "./VesselHistory.vue?vue&type=style&index=0&id=a059874e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a059874e",
  null
  
)

export default component.exports